<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">
        <vs-table
            ref="table"
            no-data-text="Sem pesquisas gravadas"
            multiple
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            :data="terms"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-end">
                <div class="flex flex-wrap-reverse items-center">
                    <!-- ACTION - DROPDOWN -->
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                        <div
                            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
                        >
                            <span class="mr-2">Ações</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="deleteTerms()">
                                <span>Apagar</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="popupActive=true">
                                <span>Compartilhar</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="term">Termos Buscados</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <p class="term font-medium">{{ tr.term }}</p>
                        </vs-td>

                        <vs-td>
                            <div class="flex">
                                <p class="details flex items-center mr-4" @click="showTerm(tr)">
                                    <vx-tooltip text="Detalhes" class="w-6 h-6" color="grey">
                                        <feather-icon icon="EyeIcon" class="w-6 h-6"></feather-icon>
                                    </vx-tooltip>
                                </p>

                                <p class="delete flex items-center text-red">
                                    <span @click="deleteTerm(tr)">
                                        <vx-tooltip text="Apagar" class="w-6 h-6" color="danger">
                                            <feather-icon icon="XCircleIcon" class="w-6 h-6"></feather-icon>
                                        </vx-tooltip>
                                    </span>
                                </p>
                            </div>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <vs-popup title="Compartilhe | Documento" :active.sync="popupActive">
            <div v-if="sharedItem || this.selected.length">
                <form @submit.prevent="submitForm">
                    <p>Insira o email de destino:</p>
                    <p class="mt-2 flex flex-wrap">
                        <vs-input
                            placeholder="Email"
                            name="email"
                            v-model="email"
                            class="mr-4 mb-4 sm:mb-0"
                        />
                        <vs-button @click.prevent="submitForm" color="success">Enviar</vs-button>
                    </p>
                    <p>
                        <small
                            class="text-red block"
                            v-if="!$v.email.required"
                        >O campo de email é obrigatório</small>
                        <small
                            class="text-red block"
                            v-if="!$v.email.email"
                        >O email digitado não é válido.</small>
                    </p>
                    <p class="mt-6">
                        Dados a serem compartilhados:
                        <br />
                    </p>

                    <div v-if="sharedItem && this.selected.length == 1">{{ sharedItem.term }}</div>

                    <div v-else-if="selected.length">
                        <ul class="mt-2">
                            <li v-for="item in selected" :key="`list-${item.id}`">{{ item.term }}</li>
                        </ul>
                    </div>
                </form>
            </div>

            <div v-else>
                <p>Por favor selecione uma pesquisa</p>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { call, sync } from "vuex-pathify";

export default {
    data() {
        return {
            itemsPerPage: 10,
            isMounted: false,
            popupActive: false,
            sharedItem: null,
            email: "",
            activeConfirm: false,
            selected: []
        };
    },
    computed: {
        ...sync([
            "search/currentPage",
            "search/pageCount",
            "search/total",
            "search/results",
        ]),
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }

            return 0;
        },
        selectedItem: sync("favoriteSearches/selected"),
        selectedIds() {
            const ids = this.selected.map(selected => selected.id);

            return ids;
        },
        terms: sync("favoriteSearches/items")
    },
    async created() {
        this.$vs.loading();
        try {
            await this.fetch();
            this.$vs.loading.close();
        } catch (error) {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Erro",
                text:
                    "Não foi possível encontrar as pesquisas salvas. Tente novamente mais tarde, por favor.",
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle"
            });
        }
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        delete: call("favoriteSearches/delete"),
        fetch: call("favoriteSearches/fetch"),
        massDelete: call("favoriteSearches/massDelete"),
        share: call("favoriteSearches/share"),
        searchByType: call("search/searchByType"),
        shareItem(item) {
            this.selected = [];
            this.popupActive = true;
            this.sharedItem = item;
        },
        deleteTerm({ id, term }) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirme`,
                text: `Você está removendo a pesquisa: "${term}"`,
                accept: async () => {
                    this.$vs.loading();

                    try {
                        await this.delete(id);
                        this.$vs.loading.close();
                    } catch (error) {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Erro",
                            text:
                                "Não foi possível excluir a pesquisa selecionada. Tente novamente mais tarde, por favor",
                            color: "danger",
                            iconPack: "feather",
                            icon: "icon-alert-circle"
                        });
                    }
                },
                acceptText: "Confirmar",
                cancelText: "Cancelar"
            });
        },
        deleteTerms() {
            if (this.selected.length < 1) {
                this.$vs.notify({
                    title: "Erro",
                    text: "Por favor, selecione algum item para apagar",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } else {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: `Confirme`,
                    text: `Você está removendo as pesquisas selecionadas.`,
                    accept: async () => {
                        this.$vs.loading();

                        try {
                            await this.massDelete(this.selectedIds);
                            this.$vs.loading.close();
                        } catch (error) {
                            this.$vs.loading.close();
                            this.$vs.notify({
                                title: "Erro",
                                text:
                                    "Não foi possível excluir a pesquisa selecionada. Tente novamente mais tarde, por favor",
                                color: "danger",
                                iconPack: "feather",
                                icon: "icon-alert-circle"
                            });
                        }
                    },
                    acceptText: "Confirmar",
                    cancelText: "Cancelar"
                });
            }
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$vs.notify({
                    title: "Erro",
                    text: "Por favor, verifique o email digitado",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } else {
                await this.sendEmail();
            }
        },
        async sendEmail() {
            const termIds = this.selected.map(term => term.id);

            try {
                this.$vs.loading();
                await this.share({ ids: termIds, email: this.email });
                this.$vs.loading.close();

                this.popupActive = false;
                this.selected = [];

                this.$vs.notify({
                    title: "Sucesso",
                    text: "Email enviado com sucesso",
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-check-circle"
                });
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text: error,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        async searchHandler(term) {
            try {
                this.$vs.loading();
                await this.searchByType({term: term, types: [], page: this.currentPage});
                await this.fetch();
                this.$vs.loading.close();
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Ocorreu um erro ao buscar os resultados. Tente novamente, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        },
        async showTerm(tr) {
            this.selectedItem = tr;
            await this.searchHandler(tr.term);
            this.$router.push({
                path: "/results",
            });
        },
        parsedType(type) {
            let parsedValue;

            switch (type) {
                case "document":
                    parsedValue = "Documento";
                    break;
                case "audio":
                    parsedValue = "Áudio";
                    break;
                case "video":
                    parsedValue = "Vídeo";
                    break;
                case "image":
                    parsedValue = "Imagem";
                    break;

                default:
                    parsedValue = type;
                    break;
            }

            return parsedValue;
        }
    },
    validations: {
        email: {
            required,
            minLength: minLength(4),
            email
        }
    }
};
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {
        .vs-table--header {
            display: flex;
            flex-wrap: wrap-reverse;
            margin-left: 1.5rem;
            margin-right: 1.5rem;
            > span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    & + i {
                        left: 1rem;
                    }

                    &:focus + i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                td {
                    padding: 20px;
                    &:first-child {
                        border-top-left-radius: 0.5rem;
                        border-bottom-left-radius: 0.5rem;
                    }
                    &:last-child {
                        border-top-right-radius: 0.5rem;
                        border-bottom-right-radius: 0.5rem;
                    }
                }
                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }
            th.td-check {
                padding: 0 15px !important;
            }
            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
